import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import MailchimpRegular from './mailchimp-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <MailchimpRegular {...validProps} />;
}
SvgComponent.iconName = 'mailchimpRegular';

export const MailchimpRegularIcon = svgIconWrapper(SvgComponent);
